import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import "typeface-roboto";
import * as serviceWorker from "./serviceWorker";
import App, { Confirm } from "@app";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "@store";
import ReactNotification from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import "./animate.css";
import { GoogleOAuthProvider } from "@react-oauth/google";

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter getUserConfirmation={Confirm}>
        <ReactNotification />
        <GoogleOAuthProvider
          clientId={
            process.env.REACT_APP_GOOGLE_AUTH_CLIENT
              ? process.env.REACT_APP_GOOGLE_AUTH_CLIENT
              : ""
          }
        >
          <App />
        </GoogleOAuthProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);
serviceWorker.unregister();
